import { ArrowRight, FileText } from "lucide-react";
import { useLang } from "@/i18n";

const OUTPUTS = [
  { ext: "JPG", color: "#00A3E0" },
  { ext: "PNG", color: "#E40046" },
  { ext: "BMP", color: "#FFB800" },
  { ext: "TIFF", color: "#0F172A" },
];

const Chip = ({ children }) => (
  <span className="whitespace-nowrap rounded-full border border-slate-200 bg-white px-3 py-1 font-mono text-[11px] font-semibold text-slate-700">{children}</span>
);

export const PdfShowcase = ({ base }) => {
  const { t } = useLang();
  const page = `${base}/pdf-doc.jpg`;
  return (
    <div className="grid-paper flex flex-col items-center gap-6 rounded-2xl p-6 sm:flex-row sm:p-8" data-testid="pdf-showcase">
      <div className="rise shrink-0">
        <div className="relative">
          <img src={page} alt="PDF" className="w-40 rounded-sm border border-slate-200 bg-white shadow-xl sm:w-44" data-testid="pdf-showcase-doc" />
          <span className="absolute -bottom-2 -left-3 flex items-center gap-1 rounded-md bg-red-600 px-2 py-1 font-mono text-[11px] font-bold text-white shadow">
            <FileText className="h-3 w-3" />PDF
          </span>
        </div>
        <p className="mt-4 text-center font-mono text-[11px] text-slate-500">annual-report.pdf · 12 {t("examples.pdfPages")}</p>
      </div>
      <div className="flex flex-col items-center gap-3">
        <span className="grid h-11 w-11 animate-pulse place-items-center rounded-full bg-slate-900 text-white"><ArrowRight className="h-5 w-5 rotate-90 sm:rotate-0" /></span>
        <div className="flex flex-wrap justify-center gap-1.5 sm:flex-col sm:items-center">
          <Chip>150 · 300 · 600 DPI</Chip>
          <Chip>RGB · CMYK</Chip>
        </div>
      </div>
      <div className="grid flex-1 grid-cols-2 gap-4">
        {OUTPUTS.map((o, i) => (
          <div key={o.ext} className="rise rounded-xl border border-slate-200 bg-white p-2.5 shadow-sm" style={{ animationDelay: `${0.1 + i * 0.1}s` }} data-testid={`pdf-output-${o.ext.toLowerCase()}`}>
            <div className="relative overflow-hidden rounded-md bg-slate-50">
              <img src={page} alt={o.ext} className="mx-auto h-28 object-contain sm:h-32" />
              <span className="absolute bottom-1.5 right-1.5 rounded px-1.5 py-0.5 font-mono text-[10px] font-bold text-white" style={{ background: o.color }}>.{o.ext.toLowerCase()}</span>
            </div>
            <p className="mt-2 flex items-center justify-between gap-2 text-xs">
              <span className="font-bold text-slate-900">{o.ext}</span>
              <span className="font-mono text-[10px] text-slate-400">2480×3508</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
